var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEquipodetrabajo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_310_117)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M489.147 767.01C473.976 748.142 441.964 740.122 440.851 714.101C439.739 688.098 445.873 653.923 461.794 626.905C476.22 602.426 439.865 563.597 458.366 540.471C481.919 511.03 567.95 468.996 603.91 460.971C642.199 452.427 651.279 519.787 683.654 528.242C710.063 535.14 748.466 513.33 773.09 522.846C799.815 533.174 815.485 556.417 823.206 582.174C831.549 610.01 842.13 644.396 818.574 674.589C793.721 706.445 740.698 702.928 708.19 729.594C677.366 754.878 675.796 799.285 641.528 819.818C607.65 840.117 565.408 842.787 536.181 832.659C507.678 822.781 506.332 788.382 489.147 767.01Z",
    fill: "url(#paint0_linear_310_117)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_310_117",
    x: 384.724,
    y: 404.224,
    width: 504.229,
    height: 490.176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28,
    result: "effect1_foregroundBlur_310_117"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_310_117",
    x1: 830.678,
    y1: 838.853,
    x2: 782.772,
    y2: 413.212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E24473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#620C90"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipodetrabajo);
export default __webpack_public_path__ + "static/media/equipodetrabajo.4a480453bfe67e61e810b1e4d96afdb5.svg";
export { ForwardRef as ReactComponent };